import React from 'react';
import { CTA_LABEL, OFFER_ANCHOR } from '../utils/checkout';
interface CTAButtonProps {
  className?: string;
  /** Defaults to the offer box anchor. Pass the checkout URL for the final purchase button. */
  href?: string;
}
export function CTAButton({
  className = '',
  href = OFFER_ANCHOR
}: CTAButtonProps) {
  const isExternal = /^https?:\/\//.test(href);
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`inline-flex items-center justify-center rounded-xl bg-terracotta px-8 py-4 text-center font-heading text-sm font-semibold tracking-[0.06em] text-white shadow-soft transition-[background-color,box-shadow,transform] duration-200 ease-out hover:bg-terracotta-dark hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 active:scale-[0.99] md:text-base ${className}`} data-id="element-65" data-mp="2g1xx45a43bhb">
      {CTA_LABEL}
    </a>;
}